module.exports = __webpack_public_path__ + "img/thunderbolt.08d6cd9e.svg";